export default __webpack_public_path__ + "static/media/mysql.276812de.png";